<p>can-deactivate-base works!</p>
